const PATH = 'fe.components.calibrations.expired_calibration';

const messages = {
  title: {
    key: `${PATH}.title`,
    defaultValue: 'Calibration Test'
  },
  subtitle: {
    key: `${PATH}.subtitle`,
    defaultValue: 'Calibration'
  },
  expiredMessage: {
    key: `${PATH}.expired_message`,
    defaultValue:
      'Your calibration has expired. Please contact Customer Support.'
  },
  contactSupport: {
    key: `${PATH}.contact_support`,
    defaultValue: 'Contact Customer Support'
  },
  logoAlt: {
    key: `${PATH}.logo_alt`,
    defaultValue: 'CLASS Calibration'
  },
  iconAlt: {
    key: `${PATH}.icon_alt`,
    defaultValue: 'CLASS calibration expired'
  }
};

export default messages;
